import { GroupPlanRow, OptInPlanRow } from '../types';
import { students } from './students';

export const optInPlanRows: OptInPlanRow[] = students.map((student) => ({
  id: `plan-${student.id}`,
  planId: student.planId,
  schoolSlug: student.schoolSlug,
  studentName: student.name,
  studentEmail: student.email,
  studentId: student.studentId,
}));

export const groupPlanRows: GroupPlanRow[] = [
  {
    id: '88BE7C92',
    planName: '88BE7C92',
    startDate: '08/31/2025',
    endDate: '05/30/2029',
    deviceTypeLabel: 'Chromebook - Non-Touch',
    seatsUsed: 0,
    seatsTotal: 5211,
  },
  {
    id: '4810CDBC',
    planName: '4810CDBC',
    startDate: '09/01/2025',
    endDate: '05/31/2026',
    deviceTypeLabel: 'iPad',
    seatsUsed: 0,
    seatsTotal: 3,
  },
];

export const coverageStats = {
  studentsCovered: 35,
  plansPurchased: 2,
  devicesCovered: 5214,
};
